export const isAdmin = (roles?: string[]) =>
  roles?.some((role) =>
    ['admin', 'atlas_admin', 'atlas_dev', 'ldap_admin'].includes(role),
  );

export const canReadApplication = (roles?: string[]) =>
  roles?.some((role) =>
    ['admin', 'atlas_admin', 'atlas_dev', 'management', 'ldap_admin'].includes(role),
  );
